(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["salon-mobile-collection-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.body.classList.contains('template-collection')) return;
  const mobile = window.matchMedia('(max-width:767px)');
  const update = () => {
    document.querySelectorAll('#Collection option[data-salon-mobile-label]').forEach(option => {
      const label = mobile.matches ? option.dataset.salonMobileLabel : option.dataset.salonDesktopLabel;
      if (option.textContent !== label) option.textContent = label;
    });
  };
  const init = () => {
    update();
    const root = document.getElementById('Collection');
    if (root) new MutationObserver(update).observe(root, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  mobile.addEventListener('change', update);
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["salon-mobile-filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      document.querySelectorAll('.salon-mobile-filters').forEach(drawer => {
        if (drawer.dataset.salonReady) return;
        const content = drawer.querySelector('.sidebar_tags');
        const results = drawer.querySelector('.salon-filter-results');
        if (!content || !results) return;
        drawer.dataset.salonReady = 'true';
        drawer.id = 'SalonCollectionFilters';
        const mobile = window.matchMedia('(max-width: 1024px)');
        const overlay = document.querySelector('.salon-filter-overlay');
        const expanded = new Map();
        let brandQuery = '';
        let focusId = '';
        let opener = null;
        const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ø/g, 'o').replace(/ß/g, 'ss');
        const filterBrands = input => {
          const group = input.closest('.salon-filter-group');
          const query = normalize(input.value.trim());
          let count = 0;
          group.querySelectorAll('.flOpt > li').forEach(item => {
            const match = !mobile.matches || normalize(item.textContent).includes(query);
            item.hidden = !match;
            if (match) count++;
          });
          group.querySelector('.salon-brand-empty').hidden = count > 0;
        };
        const setBusy = busy => {
          results.disabled = busy;
          results.setAttribute('aria-busy', String(busy));
          const count = content.querySelector('[data-salon-result-count]')?.dataset.salonResultCount;
          results.textContent = busy ? results.dataset.loadingLabel : results.dataset.label + (count === undefined ? '' : ' (' + count + ')');
        };
        const initialize = () => {
          const form = content.querySelector('#CollectionFiltersForm');
          if (!form) return;
          const groups = Array.from(form.querySelectorAll('.salon-filter-group'));
          groups.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));
          if (mobile.matches) groups.sort((a, b) => Number(b.dataset.sizeFilter === 'true') - Number(a.dataset.sizeFilter === 'true'));
          const anchor = form.querySelector(':scope > .hide');
          groups.forEach(group => {
            form.insertBefore(group, anchor);
            const key = group.dataset.filterKey;
            const open = expanded.has(key) ? expanded.get(key) : group.dataset.sizeFilter === 'true';
            group.dataset.expanded = String(open);
            group.querySelector('.salon-filter-toggle').setAttribute('aria-expanded', String(open));
          });
          const input = content.querySelector('.salon-brand-search-input');
          if (input) { input.value = brandQuery; filterBrands(input); }
          setBusy(false);
        };
        const syncOpen = () => {
          const open = mobile.matches && drawer.classList.contains('active');
          document.body.classList.toggle('salon-filters-open', open);
          if (overlay) overlay.hidden = !open;
          document.querySelectorAll('.btn-filter').forEach(button => {
            button.setAttribute('aria-controls', drawer.id);
            button.setAttribute('aria-expanded', String(open));
          });
          if (open) {
            drawer.setAttribute('role', 'dialog');
            drawer.setAttribute('aria-modal', 'true');
            drawer.setAttribute('aria-labelledby', 'SalonFilterTitle');
          } else {
            drawer.removeAttribute('role');
            drawer.removeAttribute('aria-modal');
            drawer.removeAttribute('aria-labelledby');
          }
        };
        const close = showResults => {
          drawer.classList.remove('active');
          syncOpen();
          opener?.focus({preventScroll: true});
          if (showResults) document.querySelector('#Collection .productList')?.scrollIntoView({block: 'start', behavior: 'instant'});
        };
        document.addEventListener('click', event => {
          if (!mobile.matches) return;
          const target = event.target.closest('.btn-filter, .closeFilter, .salon-filter-results, .salon-filter-toggle, .salon-filter-overlay');
          if (!target) return;
          if (!target.matches('.btn-filter, .salon-filter-overlay') && !drawer.contains(target)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (target.matches('.btn-filter')) {
            opener = target;
            drawer.classList.add('active');
            syncOpen();
            drawer.querySelector('.closeFilter').focus({preventScroll: true});
          } else if (target.matches('.salon-filter-toggle')) {
            const group = target.closest('.salon-filter-group');
            const open = group.dataset.expanded !== 'true';
            expanded.set(group.dataset.filterKey, open);
            group.dataset.expanded = String(open);
            target.setAttribute('aria-expanded', String(open));
          } else close(target.matches('.salon-filter-results'));
        }, true);
        content.addEventListener('input', event => {
          if (!event.target.matches('.salon-brand-search-input')) return;
          brandQuery = event.target.value;
          filterBrands(event.target);
        });
        content.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('.salon-brand-search-input')) event.preventDefault();
        });
        content.addEventListener('change', event => {
          if (!event.target.matches('.custCheck, .prRange, #SortBy')) return;
          focusId = event.target.id;
          setBusy(true);
        }, true);
        drawer.addEventListener('keydown', event => {
          if (!mobile.matches || !drawer.classList.contains('active')) return;
          if (event.key === 'Escape') { event.preventDefault(); close(false); }
          if (event.key !== 'Tab') return;
          const focusable = Array.from(drawer.querySelectorAll('button, input:not([type="hidden"]), select, a[href]')).filter(el => !el.disabled && el.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        });
        new MutationObserver(() => {
          initialize();
          const target = focusId && document.getElementById(focusId);
          if (target && drawer.classList.contains('active')) target.focus({preventScroll: true});
          focusId = '';
        }).observe(content, {childList: true});
        new MutationObserver(syncOpen).observe(drawer, {attributes: true, attributeFilter: ['class']});
        new MutationObserver(() => {
          if (!document.body.classList.contains('loading') && results.disabled) setBusy(false);
        }).observe(document.body, {attributes: true, attributeFilter: ['class']});
        mobile.addEventListener('change', () => { close(false); initialize(); });
        initialize();
        syncOpen();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["salon-mobile-product-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = window.matchMedia('(max-width:767px)');
  const arrange = () => {
    document.querySelectorAll('.product-single__meta').forEach(meta => {
      const slot = meta.querySelector('[data-salon-mobile-delivery]');
      const home = meta.querySelector('[data-salon-delivery-home]');
      if (!slot || !home) return;
      const status = slot.querySelector('.salon-delivery-info--status') || home.querySelector('.salon-delivery-info--status');
      const destination = mobile.matches ? slot : home;
      if (status && status.parentElement !== destination) destination.append(status);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange, { once:true });
  else arrange();
  mobile.addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', arrange);
})();
  } catch(e) { console.error(e); }
})();

})();
